import { render, staticRenderFns } from "./ProjectGroup.vue?vue&type=template&id=6f67521d&lang=pug&"
import script from "./ProjectGroup.vue?vue&type=script&lang=js&"
export * from "./ProjectGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectGroup.vue"
export default component.exports